export default {
  DORMAKABA: 'DORMAKABA',
  GUEST_ACCESS: 'GUEST_ACCESS',
  HEG_MAINTENANCE: 'HEG_MAINTENANCE',
  ORY_REGISTRATION: 'ORY_REGISTRATION',
  SITE_BLE: 'SITE_BLE',
  USER_BLE_CREDENTIAL: 'USER_BLE_CREDENTIAL',
};
